<template>
  <div id="telematicsReadingList">
      <div :class="`loader${loaderClass}`" v-show="loading"></div>
      <div id="page-content-wrapper" class="admin-content-area">
          <template v-if="cantAccessPage === true">
              <div class="page-name">
                  <div class="page-title">ACH Notice List</div>
                  <!-- Button for Clear Cache -->
                  <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                  <div class="web-action-btn btn-groups text-right">
                      <div class="web-action-btn btn-groups text-right">
                          <router-link v-bind:to="'/report/emails'" class="btn btn-secondary">
                              <i class="fp-reports"></i> Emails Report
                          </router-link>
                          <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="openModal">
                              <i class="fp-import"></i> Import
                          </a>
                      </div>
                      <!--div class="input-group">
                      <label class="control-label" for="cutoff_date" style="font-size: medium;">Select Date :</label>
                      <date-picker placeholder="MM/DD/YYYY" id="cutoff_date" name="cutoff_date"
                      v-model="due_date" :config="optionsDate"></date-picker>

                      <a href="javascript:void(0)" class="btn btn-secondary ml-3" v-on:click="fetchInvoice">
                          Fetch
                      </a>
                      </div-->
                  </div>
                  <!--div class="mobile-action-btn elipse-btn">
                      <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left" aria-expanded="false" v-on:click.prevent="myFunction">
                          <i class="fp-ellipsis-v"></i>
                      </button>
                      <div id="myDropdown" class="dropdown-content">
                          <ul>
                              <li>
                                  <label class="control-label" for="cutoff_date" style="font-size: medium;">Select Date :</label>
                                    <date-picker placeholder="MM/DD/YYYY" id="cutoff_date" name="cutoff_date"
                                    v-model="due_date" :config="optionsDate"></date-picker>
                              </li>
                              <li>
                                  <a href="javascript:void(0)" class="" v-on:click="fetchInvoice">Fetch</a>
                              </li>
                          </ul>
                      </div>
                  </div-->
                  <div class="mobile-action-btn elipse-btn">
                        <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left" aria-expanded="false" v-on:click.prevent="myFunction">
                            <i class="fp-ellipsis-v"></i>
                        </button>
                        <div id="myDropdown" class="dropdown-content">
                            <ul>
                                <li>
                                    <router-link v-bind:to="'/report/emails'" class="">Emails Report</router-link>
                                </li>
                                <li>
                                    <a href="javascript:void(0)" class="" v-on:click="openModal">Import</a>
                                </li>
                            </ul>
                        </div>
                    </div>
              </div>
              <div class="container-fluid">
                  <div class="admin-page-content courtesy-notice-list">
                      <data-table-filter-config :moduleName="'achNoticeList'" ref="filterACHNotice" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                      <section class="data-table bg-white">
                              <custom-pagination
                                  :page-changed="onPageChange"
                                  :per-page-changed="onPerPageChange" :moduleName="'achNoticeList'" :position="'top'">
                              </custom-pagination>

                              <vue-good-table
                                  ref="noticeList"
                                  mode="remote"
                                  title="ACH Notices"
                                  @on-row-click="onRowClick"
                                  @on-page-change="onPageChange"
                                  @on-selected-rows-change="selectionChanged"
                                  @on-column-filter="onColumnFilter"
                                  @on-per-page-change="onPerPageChange"
                                  @on-sort-change="onSortChange"
                                  @on-select-all="onSelectAll"
                                  :totalRows="totalRecords"
                                  :columns="userColumns"
                                  :rows="rows"
                                  :pagination-options="{
                                      enabled: false,
                                      position: 'both',
                                      perPage: perPage,
                                      perPageDropdown:dropDownPerPage,
                                      setCurrentPage:listCurrentPage,
                                      dropdownAllowAll: false,
                                  }"
                                  :select-options="{
                                      enabled: notices,
                                      selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                      selectionInfoClass: 'custom-class',
                                      selectionText: 'rows selected',
                                      clearSelectionText: 'clear',
                                  }"

                                  :search-options="{
                                      enabled: false,
                                  }">
                                  <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                      <div :key="key">
                                          <div v-if="props.column.field == 'action'">
                                              <a href="javascript:void(0)" title="View" class="fp-view" v-on:click="viewMailTemplate(props.row.id)"></a>
                                          </div>
                                          <div v-else>
                                              <span v-fp-html="props.formattedRow[props.column.field]"></span>
                                          </div>
                                      </div>
                                  </template>
                                    <div slot="selected-row-actions">
                                      <button v-if="canSendCourtesyNotice" id="send" v-on:click.prevent="performTask('send')" class="btn btn-primary">Send Notification</button>
                                      <button v-if="canDeleteAchNotice" id="deleteAchNoticeBtn" v-on:click.prevent="deleteACHNotice" class="btn btn-danger">Delete</button>
                                  </div>
                              </vue-good-table>
                              <custom-pagination
                                  :page-changed="onPageChange"
                                  :per-page-changed="onPerPageChange">
                              </custom-pagination>
                      </section>

                      <div class="modal fade invoice-modal update-reading-modal" id="myModal" ref="myModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
                          <div class="modal-dialog" role="document">
                              <div class="modal-content">
                                  <div class="modal-header">
                                      <h5 class="modal-title">Select File</h5>
                                  </div>
                                  <div class="modal-body">
                                      <form id="importFile" class="form-inline addinspectionForm basic-form-container">
                                          <div class="form-row">
                                              <div class="col-md-12 form-group">
                                                  <label class="control-label require" for="typeImage">File:</label>
                                                  <input id="typeImage" type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.template, application/vnd.ms-excel.sheet.macroEnabled.12, application/vnd.ms-excel.template.macroEnabled.12, application/vnd.ms-excel.addin.macroEnabled.12, application/vnd.ms-excel.sheet.binary.macroEnabled.12" @change="onFileChanged">
                                              </div>
                                              <span class="field-error">{{error}}</span>
                                          </div>
                                      </form>
                                      <template v-if="notFoundArr.length > 0">
                                          <p class="field-error">{{notValid}}:</p>
                                          <template v-for="(unit ,key) in notFoundArr">
                                              <span :key="key"> {{unit}}<a v-if="key < notFoundArr.length - 1">,</a></span>
                                          </template>
                                      </template>
                                  </div>
                                  <div class="modal-footer btm-action-btn-fl">
                                      <button v-if="!notfound" class="btn btn-primary" id="myButton" v-on:click="importReport()" > <i class="fp-import"> </i> Import</button>
                                      <button v-else class="btn btn-primary" id="okbutton" v-on:click="loadList()" data-dismiss="modal">OK</button>
                                      <button v-if="!notfound" type="button" class="btn btn-tertiary" data-dismiss="modal" ><i class="fp-close"> </i>Cancel</button>
                                      <button v-else type="button" class="btn btn-tertiary" v-on:click="loadList()" data-dismiss="modal" > <i class="fp-close"> </i><i class="fp-close"> </i> Cancel</button>
                                  </div>
                              </div>
                          </div>
                      </div>

                      <div class="modal fade invoice-modal notice-modal-top" id="invoice_modal" ref="invModal" data-backdrop="static" data-keyboard="false" aria-labelledby="invModal" aria-hidden="true">
                            <div :class="`loader${loaderClass}`" v-show="modalLoading">
                            </div>
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content notice-modal">
                                    <div class="modal-header">
                                        <h5 class="modal-title">ACH Notice</h5>
                                    </div>
                                    <div class="modal-body">

                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-tertiary" data-dismiss="modal"> <i class="fp-close"> </i> Cancel </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                  </div>
              </div>
          </template>
          <template v-else-if="cantAccessPage === false">
              <div class="container-fluid">
                  <div class="bg-white text-center">
                      <h1>
                          Oops!</h1>
                      <h2>
                          403 </h2>
                      <div class="error-details">
                          Sorry!, You don't have permission to access this page.
                      </div>
                  </div>
              </div>
          </template>
          <template v-else>
              <loading-content></loading-content>
          </template>
          <app-footer></app-footer>
      </div>
  </div>
</template>

<script>

import EventBus from "./../event-bus";
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';

export default {
    name: "achList",
    mixins:[commonMixins,dataTableMixins],
    metaInfo() {
        return {
            title: "ACH Notice List | " +process.env.COPYRIGHT_NAME
        }
    },
    data: () => (
      {
            due_date: "",
            optionsDate: {
                format: 'MM/DD/YYYY',
                useCurrent: true,
            },
            firstLoad: 0,
            permissions: [],
            cantAccessPage: true,
            selectedFile:"",
            deviceType:"",
            error:"",
            notfound:false,
            notFoundArr:[],
            unitNum:"",
            reading:"",
            section:"",
            id:0,
            userColumns:[],
            columns: [
                {
                    label: 'Action',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: 'Customer',
                    field: 'customer_name',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Customer", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Email',
                    field: 'email',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Email", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                    html:true,
                },
                {
                    label: 'Status',
                    field: 'status',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Status", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        // filterDropdownItems: ['Queued','Sent','Opened','Failed'],
                        filterDropdownItems: ['Queue','Sent','Opened','Failed','Pending'],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Notify Times',
                    field: 'notification_count',
                    filterable: true,
                    fpFieldType:"integer",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Notified", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [],
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Reminder Date',
                    field: 'reminder_date',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Sent Date',
                    field: 'sent_date',
                    fpFieldType:"date",
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Sent By',
                    field: 'sent_by',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Sent By", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },

            ],
            rows: [],
            totalRecords: 0,
            customer_value: false,
            loading:false,
            fromDate:"",
            readingError:"",
            unit:"",
            readingDate:"",
            notices:true,
            reqeustSent:0,
            send_date:"",
            modalLoading:false,
            notValid:'',
            action:'list',
            canSendCourtesyNotice:false,
            pageKey:"_notice_list_",
            canDeleteAchNotice:false
      }
    ),
    watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'list_ach_notice') {
                        self.cantAccessPage = true;
                        self.notices = true;
                    }
                    if (permissions[i].name == 'send_ach_notice') {
                        self.canSendCourtesyNotice = true;
                    }
                    if (permissions[i].name == 'delete_ach_notice') {
                        self.canDeleteAchNotice = true;
                    }
                }
            }

        }

    },
    created: function() {

    },

    mounted: function() {
        var self = this;
        // $("#invoice_modal").modal("hide");
        this.getPermissions();
    },
     methods: {
            openModal: function(){
                var self = this;
                self.error = "";
                $('#myButton').html('<i class="fp-import"></i>' + 'Import');
                self.notFoundArr = [];
                self.selectedFile = "";
                self.notfound = false;
                $("#typeImage").val('');
                $('#myModal').modal('show');
            },
            cancelAll: function (cancelAll) {
              this.$refs.noticeList.unselectAllInternal();
            },
            viewMailTemplate(id){

                var self = this;
                $("#invoice_modal .modal-body").html("");
                $("#invoice_modal").modal("show");
                self.modalLoading = true;
                $.ajax({
                    url: process.env.ROOT_API + "/invoice-notice/template",
                    type: "POST",
                    data: {id:id},
                    dataType:"html",
                    crossDomain:true,
                    headers: this.ajxHeaders,
                    success: function (data) {

                        $("#invoice_modal .modal-body").html("");
                        // $("#invoice_modal").modal("show");

                        $("#invoice_modal .modal-body").html(data);
                        // self.send_date = data;
                        self.modalLoading = false;


                    },
                    error: function (jqXHR, exception) {
                        self.modalLoading = false;
                        self.reqeustSent = 0;

                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'invoice-notice-template');
                    }
                });

            },
            fetchInvoice() {
              var self = this;
              console.log("fetchInvoice")
              console.log(self.due_date);
              $.ajax({
                url: process.env.ROOT_API + "/invoice-notice/act_import",
                type: "POST",
                data: {
                  due_date: self.due_date
                },
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (data.code == 200) {
                      self.loadList();
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (self.action == "notification") {
                        self.generateStatusCodeMessage(jqXHR,true,'send-notification');
                    }else{
                        self.generateStatusCodeMessage(jqXHR,false,'courtesy-notice-list');
                    }
                }
            });

            },
            onRowClick(params) {

               console.log(params.event.target);
               var self = this;

               if ( $(params.event.target).hasClass("vgt-checkbox-col")  || $(params.event.target).hasClass("fp-open")) {
                   return;
               }

               if ( self.reqeustSent == 1 ) {
                   return;
               }

                //if data already available than remove it
                if ( $(params.event.target.closest('.clickable').nextSibling).hasClass("invoiceDetails")) {
                    $(params.event.target.closest('.clickable').nextSibling).remove();
                    return;
                }

                //generate html
                var html = '<tr class="invoiceDetails"><td colspan="5"><table aria-describedby="table" class="table">';
                    html += '<tr><th>Invoice No.</th><th>Invoice Date</th><th>Due Date</th><th class="text-right">Open Amount</th></tr>';

               var fields = {
                            customerId:params.row.id,
                        };
                self.reqeustSent = 1;

               $.ajax({
                    url: process.env.ROOT_API + "/invoice-notice/details",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {

                        self.reqeustSent = 0;
                        self.loading = false;
                        if ( data.code == 200 ) {

                            //check data records
                            if ( data.content.length > 0 ) {

                                for ( var j=0; j<data.content.length; j++ ) {
                                    html += '<tr><td>'+data.content[j].invoiceNo+'</td><td>'+data.content[j].invoiceDate+'</td><td>'+data.content[j].dueDate+'</td><td class="vgt-right-align">$'+data.content[j].amount+'</td></tr>';
                                }

                            } else {
                                html += '<tr><td colspan="4">No record found.</td></tr>';
                            }

                            html += '</table></td></tr>';
                            $(html).insertAfter(params.event.target.closest('.clickable'));

                        }
                    },
                    error: function (jqXHR, exception) {

                        self.reqeustSent = 0;

                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'invoice-notice-detail');
                    }
                });
            },
            selectionChanged(param) {
                var self = this;
                self.serverParams.selectedAll = false;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                return;
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['noticeList'].selectedRows;
                // console.log(rowData);
            },
            /*onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadList();
            },*/

            loadList() {
                $('table tr.invoiceDetails').remove();  //remove row of details if any open
                var self = this;

                var data = this.$refs['noticeList'].selectedRows;
                var selectedCust = [];

                for (var i = 0; i < data.length; i++) {
                    selectedCust.push(self.$refs['noticeList'].selectedRows[i].id)
                }

                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    asset_id: self.assetId,
                    all:self.serverParams.selectedAll,
                    id:selectedCust,
                    flag:'ach_notice',
                    action:self.action,
                    // selectedAll:self.serverParams.selectedAll
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/invoice-notice/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // $("#myModal").modal('hide');

                        // console.log(data);
                        if (data.status == "success") {

                            if ( self.action == "notification" ) {

                                self.action = "list";
                                self.$refs.noticeList.unselectAllInternal();
                                self.$swal('','Notice has been sent to the customer','success');
                                self.loadList();
                                EventBus.$emit('clear-all-flags', false);   //hide alert of selection
                            }else if (self.action == "delete") {
                                self.action = "list";

                                var msg = "";
                                if (data.content > 1) {
                                    msg = data.content+" records have been deleted with Pending Status.";
                                }else{
                                    msg = data.content+" record have been deleted with Pending Status.";
                                }

                                self.$swal('',msg,data.status);
                                EventBus.$emit('clear-all-flags', false);
                                self.loadList();
                                return;
                            }else{
                                self.rows = data.row;
                                self.totalRecords = data.totalRecords;
                            }
                            // self.filteredFlag = false;

                                // self.loadList();
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (self.action == "notification") {
                            self.generateStatusCodeMessage(jqXHR,true,'send-notification');
                        }else{
                            self.generateStatusCodeMessage(jqXHR,false,'courtesy-notice-list');
                        }
                    }
                });
            },
            onFileChanged (event) {
                const file = event.target.files[0]

                console.log(event.target);
                var self = this;
                var type = file.type;
                console.log("file = ", type);
                if(type === 'application/vnd.ms-excel'
                || type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.template'
                || type === 'application/vnd.ms-excel.sheet.macroEnabled.12' || type === 'application/vnd.ms-excel.template.macroEnabled.12'
                || type === 'application/vnd.ms-excel.addin.macroEnabled.12' || type === 'application/vnd.ms-excel.sheet.binary.macroEnabled.12') {
                  self.error = "";
                  self.selectedFile = file;
                  self.notfound = false;
                  self.notFoundArr = [];
                  console.log(self.selectedFile);
                } else {
                  var extention = file.name.split('.').pop();
                  self.error = extention + " is not supporter file type, please select excel";
                }

            },
            importReport: function(){
                var self = this;

                if(self.selectedFile == "" || self.selectedFile == null){
                    self.error = "Please Select Excel File.";
                    return;
                }else{
                    self.error = "";
                }
                var formData = new FormData();
                formData.append('myFile', self.selectedFile);
                // formData.append('fileName', self.selectedFile.name);
                formData.append('fileName', 'ACHNotice');
                // formData.append('device', self.deviceType);

                self.loading = true;
                $('#myButton').text('Fetching...');
                $('#myButton').prop('disabled',true);
                $.ajax({
                    url: process.env.ROOT_API + "/customer_notice/import_data",
                    type: "POST",
                    // data: {name: self.name, code: self.code, is_default: self.checkboxValue, id: segments[3]},
                    data: formData,
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    success: function (data) {
                        $('#myButton').html('<i class="fp-import"></i>' + 'Import');
                        $('#myButton').prop('disabled',false);
                        self.loading = false;
                        if(data.code == 201){
                            if(data.invalidEmail.length > 0){
                                self.notValid = data.failed;
                                self.notfound = true;
                                $('#myButton').text('OK');
                                self.notFoundArr = data.invalidEmail;
                            }else{
                                self.error = data.message;
                            }

                            return;
                        }
                        if (data.status == "success") {
                            self.error = "";
                            if(data.invalidEmail.length > 0){
                                self.notValid = data.failed;
                                self.notfound = true;
                                $('#myButton').text('OK');
                                self.notFoundArr = data.invalidEmail;
                            }else{
                                $('#myModal').modal('hide');
                                self.loadList();
                            }

                        }
                    },
                    error: function (jqXHR, exception) {
                        $('#myButton').html('<i class="fp-import"></i>' + 'Import');
                        $('#myButton').prop('disabled',false);
                      self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'courtesy-notice-import');
                    }
                });
            },


        performTask: function(flag) {

            var self = this;

            self.action = 'notification';
            self.loadList();
            return;
            // var data = this.$refs['noticeList'].selectedRows;
            // var selectedCust = [];

            // for (var i = 0; i < data.length; i++) {
            //     selectedCust.push(self.$refs['noticeList'].selectedRows[i].id)
            // }

            // $.ajax({
            // url: process.env.ROOT_API + "/invoice/notices",
            // type: "POST",
            // data:{
            //     id:selectedCust,
            // },
            // // data: {name: self.name, code: self.code, is_default: self.checkboxValue, id: segments[3]},
            // headers: this.ajxHeaders,
            // dataType: "json",
            // success: function (data) {

            //     self.loading = false;

            //     if(data.code == 201){

            //     }
            //     if (data.status == "success") {
            //         if ( flag == "send" ) {
            //             self.$swal('','Notice has been sent to the customer','success');
            //         }
            //         self.loadList();
            //     }
            // },
            // error: function (jqXHR, exception) {
            //     $('#myButton').text('Import');
            //     $('#myButton').prop('disabled',false);
            //     self.loading = false;
            //     self.generateStatusCodeMessage(jqXHR,true,'courtesy-notice-task');
            // }
            //  });
        },
        deleteACHNotice() {
                var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete this ACH Notice?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        self.action = "delete";
                        self.loadList();
                    } else {
                    }
                });
            }

      }

}
</script>


// WEBPACK FOOTER //
// src/components/invoice/ACHNotification.vue